// extracted by mini-css-extract-plugin
module.exports = {"errorWrapper":"error-indicator_errorWrapper__33YP1","relative":"error-indicator_relative__6nySi"};